import React from 'react'
import { backgroundColorCounter, marginLarge, spaceBetween } from '../style';
import { useTranslation } from 'react-i18next';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";

// import Swiper core and required modules
import SwiperCore, {
  Pagination, Navigation
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

interface ItemTestimonial {
    full_name: string
    image : string
    origin: string
    rank: number
    review: string
}

const Testimonials = ({items}) => {
  const { t } = useTranslation();
    function showRank(rank:number) {
        let key =1
        let stars = [<li key={key}><i className="fas fa-star"></i></li>];
        --rank
        ++key
        while(rank>=1){
            stars.push(<li key={key}><i className="fas fa-star"></i></li>)
            --rank;
            ++key
        }
        // if(rank>0)
        //     stars.push("fas fa-star-half-o")
        while(stars.length<5){
            stars.push(<li key={key} className="knsl-empty"><i className="fas fa-star"></i></li>)
            ++key
        }
        return(
            <ul className="knsl-stars">
                {stars.map((star,index) => star)}
            </ul>
        )
    }

    function itemTestimonial(item:ItemTestimonial, index:number) {
        return(
          <SwiperSlide key={index}>
                <div className="knsl-testimonial-card">
                    <div className="knsl-avatar-frame">
                        <img src={item.image} alt={item.full_name} />
                    </div>
                    <div className="knsl-name-and-text">
                        <h3 className="knsl-mb-10">{item.full_name}</h3>
                        <div>{t('main.from') + ' ' + t(`main.${item.origin}`)}</div>
                        <blockquote>
                            {showRank(item.rank)}
                            {item.review}
                        </blockquote>
                    </div>
                </div>
          </SwiperSlide>
        )
    }
    
    return(
        <section className="knsl-transition-top knsl-p-0-80" style={backgroundColorCounter}>
          <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12">

                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-80">
                  <h2 className="knsl-mb-20">{t('main.guestFeedback')}</h2>
                  <p>{t('main.guestFeedbackDesc')}</p>
                </div>

              </div>
            </div>

          </div>
        {/* <!-- slider --> */}
          <div style={marginLarge}>
          <Swiper  className="knsl-testimonials-slider knsl-scroll-animation"
            slidesPerView={1} 
            spaceBetween={20} 
            parallax={true}
            updateOnWindowResize={true} initialSlide={1} 
            speed={800} 
            breakpoints={{1200 : {slidesPerView: 3}, 760 : {slidesPerView: 2}} } 
            centeredSlides={true}
            navigation={{prevEl: '.knsl-testimonials-slider-1-prev',nextEl: '.knsl-testimonials-slider-1-next'}}
          >
            {items.map((item:ItemTestimonial, index) => itemTestimonial(item, index))}

            {/* <!-- slider navigation --> */}
            <div className="knsl-testimonials-nav row justify-content-center">
              <div className=" col-lg-5 col-sm-8" style={spaceBetween}>
                <div className="knsl-testimonials-slider-1-prev"><i className="fas fa-arrow-left"></i></div>
                <div className="knsl-testimonials-slider-1-next"><i className="fas fa-arrow-right"></i></div>
              </div>
            </div>
            {/* <!-- slider navigation end --> */}
          </Swiper>
          </div>
          
       {/* <!-- slider end --> */}
        </section>
    )
}

export default Testimonials